import React, { ErrorInfo } from "react";
import { ErrorComponent } from "../components/ErrorComponent";
import * as Sentry from "@sentry/react-native";
import * as SplashScreen from "expo-splash-screen";
import { KeyboardProvider } from "react-native-keyboard-controller";

interface ErrorBoundaryProps {
    children?: React.ReactNode;
}

interface ErrorBoundaryState {
    error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public state: ErrorBoundaryState = {
        error: null,
    };

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        // Update state so the next render will show the fallback UI.
        return { error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        Sentry.captureException(typeof error === "string" ? new Error(error) : error);
        console.warn("Uncaught error:", error, errorInfo);
        SplashScreen.hide();
    }

    clearError() {
        this.setState({ error: null });
    }
    render() {
        if (this.state.error) {
            const error = new Error(this.state.error.message || this.state.error.toString());
            // This boundary sits above the app's KeyboardProvider, and the fallback replaces the
            // subtree that contained it. ErrorComponent renders a ScreenCard, whose
            // KeyboardAwareScrollView crashes without a keyboard context.
            return (
                <KeyboardProvider>
                    <ErrorComponent error={error} onClose={() => this.clearError()} />
                </KeyboardProvider>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
